"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDivider = exports.StyledPrimaryText = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Divider = _interopRequireDefault(require("../../../IconicDisplayElements/Divider"));

var _PrimaryText = _interopRequireDefault(require("../../BasicTextElements/PrimaryText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "SectionHeaderstyles__Wrapper",
  componentId: "sc-1hzj98k-0"
})([""]);

exports.Wrapper = Wrapper;
var StyledPrimaryText = (0, _styledComponents.default)(_PrimaryText.default).withConfig({
  displayName: "SectionHeaderstyles__StyledPrimaryText",
  componentId: "sc-1hzj98k-1"
})(["font-weight:", ";line-height:1.5rem;width:100%;"], function (props) {
  return props.theme.primaryHeavy;
});
exports.StyledPrimaryText = StyledPrimaryText;
var StyledDivider = (0, _styledComponents.default)(_Divider.default).withConfig({
  displayName: "SectionHeaderstyles__StyledDivider",
  componentId: "sc-1hzj98k-2"
})(["margin-top:0;"]);
exports.StyledDivider = StyledDivider;